<section class="mt-4 flex justify-center align-middle">
    <div class=" flex loader w-48 h-48 relative justify-center items-center">
        <span class="w-full h-full border-2 border-black pointer-events-none absolute animate-loader-animation"></span>
        <span class="w-full h-full border-2 border-black pointer-events-none absolute animate-loader-animation"></span>
        <span class="w-full h-full border-2 border-black pointer-events-none absolute animate-loader-animation"></span>
        <h4 class="text-black font-medium">Уншиж байна...</h4>
    </div>
</section>